export const SIGNATURE_STATUS = {
  IDLE: 'idle',
  GENERATING: 'generating',
  PENDING: 'pending',
  COMPLETED: 'completed',
  EXPIRED: 'expired',
  SUPERSEDED: 'superseded',
  NOT_SIGNABLE: 'not_signable',
  ERROR: 'error'
};
